import {
  ChangeDetectorRef,
  Component,
  computed,
  EventEmitter,
  Input,
  OnInit,
  Output,
  signal,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import {
  DataService as CoreDataService,
  Query,
  QueryColumn,
  QueryColumnSortOrder,
  QueryObjectsModel,
} from "@barthauer/abc/core/data";
import { ResourceManager } from "@barthauer/abc/core/resources";
import {
  _AbcFormComponent,
  _AbcScrollViewComponent,
  _AbcSelectBoxComponent,
} from "@barthauer/abc/ui-components";
import { Address } from "@barthauer/custom/arena";
import { Project } from "@barthauer/custom/xmt-models";
import { DxScrollViewComponent } from "devextreme-angular";
import { loadMessages, locale } from "devextreme/localization";
import { forkJoin, Observable, of, Subject, Subscription } from "rxjs";
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  finalize,
  switchMap,
} from "rxjs/operators";
import { AppService } from "../../../services/app.service";
import { DataService, ObjectKeys } from "../../../services/data.service";
import { LanguageService } from "../../../services/language.service";
import { CompaniesService, IProjectDependency } from "../companies.service";
import { CompanySelectionService } from "../company-selection.service";
import { FavoritesService } from "../../favorite/favorites.service";
import { NotificationService1 } from "../../../services/notification1.service";

@Component({
  selector: "companies-card-list",
  templateUrl: "./companies-card-list.component.html",
  styleUrls: ["./companies-card-list.component.scss"],
  standalone: false,
  providers: [CompanySelectionService],
})
export class CompaniesCardListComponent implements OnInit {
  @ViewChild(DxScrollViewComponent, { static: true })
  scrollView: _AbcScrollViewComponent;
  @ViewChild("filterField") filterField: _AbcSelectBoxComponent;
  @ViewChild("form") form: _AbcFormComponent;
  @Input() displayGrid: boolean = true;
  @Input() navigateUrl: string;
  @Input() companyIdDependency: IProjectDependency;
  @Input() companyNameDependency: IProjectDependency;
  @Input() configDependencies: IProjectDependency[];
  @Input() filterOptions: [] = [];
  @Output() filterData = new EventEmitter<QueryColumn[]>();
  @Output() clickProject = new EventEmitter<Project[]>();
  @Output() clickCompany = new EventEmitter<Address>();
  @Output() selectLastProjectUpdated = new EventEmitter<Project>();
  public searchTerm = new Subject<string>();
  public blurPage = true;
  public companies: Address[];
  public company: Address;
  public companySelected: Address = new Address(null);
  // public isCompanySelected: boolean = false;
  public originalCompanyData: Address;
  public cachedStatus = [];
  public cachedCompaniesTitles: string[] = [];
  public clonedCompanies: Address[];
  public columns: QueryColumn[] = [];
  public emptyCompany = false;
  public filterActive = false;
  public items = [];
  public isFavorite = false;
  public res!: any;
  public resourceManager!: ResourceManager;
  // public projectList: Project[] = [];

  private comapnyNumber = 100;
  private subscriptions: Subscription[] = [];
  public selectedCompany: string = "";
  currentLanguage: string | null;
  protected projects = signal<Project[]>([]);
  protected searchValue = "";
  protected isCompanySelected = computed(() =>
    this.appService.isCompanySelected(),
  );
  constructor(
    private coreDataService: CoreDataService,
    private companiesService: CompaniesService,
    private companySelectionService: CompanySelectionService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private languageService: LanguageService,
    public appService: AppService,
    public dataService: DataService,
    public favoriteService: FavoritesService,
    private notificationService: NotificationService1,
  ) {
    this.res = ResourceManager.getResources("ubt-geods");
  }
  public ngOnInit(): void {
    this.appService.projectName.set("");
    this.appService.measureName.set("");
    this.appService.subProjectName.set("");

    this.subscriptions.push(
      this.languageService.localStorageChanges$.subscribe((value) => {
        this.currentLanguage = value;
        this.updateTranslations();
      }),
    );
    this.filterCompanyWithProject();
    this.company = new Address(null);
    this.blurPage = false;
    this.subscriptions.push(
      this.search(this.searchTerm).subscribe((results) => {
        if (this.appService.isCompanySelected()) {
          this.projects.set(results ?? this.appService.projectList);
        } else {
          this.companies = [];
          this.emptyCompany = false;
          if (results !== null) {
            this.filterActive = true;
            if (results.length === 0) {
              this.emptyCompany = true;
            } else {
              this.companies = results;
            }
          } else {
            this.companies = this.clonedCompanies.slice(
              0,
              this.comapnyNumber + 100,
            );
          }
        }
        this.cdr.markForCheck();
      }),
    );

    this.subscriptions.push(
      this.companiesService.updateGridData$.subscribe((company: Address) => {
        this.companies.push(company);
      }),
    );

    this.subscriptions.push(
      this.companiesService.selectedCompanyData$.subscribe(
        (selectedCompany) => {
          if (selectedCompany === true) {
            this.getProjectsPersonData();
            this.getCompanySelected();
          }
        },
      ),
    );
  }
  public hoverCompanyAction(event) {
    this.appService.isCompanySelected.set(true);
    this.selectedCompany = event;
  }
  public resetSearch(event): void {
    if (event.value === "") {
      this.searchTerm.next("");
    }
  }

  public switchToCompanyProject(): void {
    this.appService.isCompanySelected.set(true);
  }

  public filterCompanyWithProject() {
    this.subscriptions.push(
      this.companiesService.filterCompanyData$.subscribe(
        (filteredCompanies: Address[] | number) => {
          if (typeof filteredCompanies === "number") {
            this.filterField.value =
              this.filterOptions[filteredCompanies]["id"];
            this.prepareFiltredData();
          } else {
            this.companies = filteredCompanies.slice(0, this.comapnyNumber);
            this.clonedCompanies = [...filteredCompanies];
            this.items = this.clonedCompanies.map((filteredCompanies) => {
              return {
                ...filteredCompanies,
                searchProperty: filteredCompanies.Name.toUpperCase(),
              };
            });
            this.cdr.markForCheck();
          }
        },
      ),
    );
  }

  public prepareCompanyData() {
    this.subscriptions.push(
      this.companySelectionService.prepareCompanyList().subscribe(
        (companiesData) => {
          this.companies = companiesData.slice(0, this.comapnyNumber);
          this.clonedCompanies = [...companiesData];
          this.items = this.clonedCompanies.map((company) => {
            return { ...company, searchProperty: company.Name.toUpperCase() };
          });
          this.cdr.markForCheck();
        },
        (error) => {
          console.error(error);
        },
      ),
    );
  }

  public navigateToDashboard(project): void {
    this.appService.switchTreeViewToProject(true);
    sessionStorage.setItem("projectId", project.Id);
    sessionStorage.setItem("projectName", project.Label);
    this.appService.projectName.set(project.Label);
    this.appService.treeViewSwitchToProject.next(true);
    this.favoriteService.resetFavorites()
    this.router.navigate(["dashboard"]);
  }

  public clickCompanyAction(): void {
    this.dataService.clearRoles();

    const personId = sessionStorage.getItem("profileId");
    const profileAddressId = sessionStorage.getItem("profileAddressId");

    forkJoin({
      userPermission: this.dataService
        .loadUserRole(profileAddressId, personId)
        .pipe(
          catchError((err) => {
            console.error("Failed to load user role", err);
            return of(null);
          }),
        ),
      notification: this.notificationService.reloadNotifications(),
    }).subscribe({
      next: ({ userPermission, notification }) => {
        if (userPermission) {
          this.appService.treeViewSwitchToCompany.next(true);
        }
        this.switchToCompanyProject();
        this.searchTerm.next("");
        this.searchValue = "";
      },
      error: (err) => {
        console.error("Unexpected forkJoin error", err);
        this.switchToCompanyProject();
        this.searchTerm.next("");
        this.searchValue = "";
      },
    });
  }

  public selectLastProjectUpdatedAction(project): void {
    this.selectLastProjectUpdated.emit(project);
  }

  private getCompanySelected() {
    const companyId = sessionStorage.getItem("profileAddressId");
    const opath = "Id=" + "'" + companyId + "'";
    this.companiesService
      .readObjects<Address[]>(ObjectKeys.ADDRESS, this.columns, opath)
      .pipe(
        finalize(() => {
          this.cdr.markForCheck();
        }),
      )
      .subscribe(
        (company) => {
          if (Array.isArray(company) && company.length > 0) {
            this.companySelected = company[0];
          } else {
            this.companySelected = new Address(null);
          }
        },
        (error) => {
          console.error(error);
          this.cdr.markForCheck();
        },
      );
  }

  public redirectToCompanies() {
    this.appService.isCompanySelected.set(false);
    this.searchValue = "";
    this.searchTerm.next("");
  }

  private getProjectsPersonData() {
    const companyId = sessionStorage.getItem("profileAddressId");
    const profileId = sessionStorage.getItem("profileId");

    const opath = `Project.ParentId='${companyId}' And IdRefPerson='${profileId}'`;
    this.companiesService
      .readObjects<
        Project[]
      >(ObjectKeys.PROJECT_PERSON, this.companiesService.projectPersonColumns, opath)
      .subscribe(
        (projects) => {
          if (Array.isArray(projects) && projects.length > 0) {
            this.appService.projectList = projects;
            this.projects.set(projects);
          } else {
            this.appService.projectList = [];
            this.projects.set([]);
          }
        },
        (error) => {
          console.error(error);
          this.cdr.markForCheck();
        },
        () => {
          this.cdr.markForCheck();
        },
      );
  }

  public search(terms: Observable<string>) {
    return terms.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      switchMap((term) => this.searchEntries(term)),
    );
  }

  public searchEntries(term: string) {
    if (!term) return of(null);
    term = term.toUpperCase();
    return this.appService.isCompanySelected()
      ? of(
          this.appService.projectList.filter((project) =>
            project.Label.toUpperCase().includes(term),
          ),
        )
      : of(this.items.filter((a) => a.searchProperty.indexOf(term) >= 0));
  }

  public selectFilterOption(event) {
    const filterAction = event.itemData.id;
    if (filterAction === 0) {
      this.prepareCompanyData();
    } else if (filterAction === 1) {
      this.prepareFiltredData();
    }
  }
  public prepareFiltredData() {
    const opath = "Exists(Address.Projects)";
    this.subscriptions.push(
      this.companySelectionService
        .prepareCompanyList(undefined, opath)
        .subscribe((companiesData) => {
          if (Array.isArray(companiesData) && companiesData.length > 0)
            this.companiesService.filterCompanyData(companiesData);
        }),
    );
  }

  updateTranslations(): void {
    if (this.currentLanguage === "de" || this.currentLanguage === null) {
      loadMessages("de");
      locale("de");
    } else {
      loadMessages("en");
      locale("en");
      ResourceManager.changeLanguage(this.currentLanguage);
    }
    this.cdr.detectChanges();
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}
